import { apiMethod } from '../../../shared';
import { APINames } from 'src/shared';

// 移除搜索到新设备的事件的全局监听函数。
export function offBluetoothDeviceFound() {
  apiMethod.off(APINames.Native.ON_BLUETOOTH_DEVICE_FOUND);
}
